import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AutomationCriteriaValueComponent } from './automation-criteria-value/automation-criteria-value.component';
import { AutomationCriteriaComponent } from './automation-criteria/automation-criteria.component';
import { AutomationRuleSummaryComponent } from './automation-rule-summary/automation-rule-summary.component';
import { AutomationRuleComponent } from './automation-rule/automation-rule.component';
import { RuleAutomationService } from './rule-automation.service';

@NgModule({
  imports: [
    GCCoreModule
  ],
  providers: [
    RuleAutomationService
  ],
  declarations: [
    AutomationCriteriaComponent,
    AutomationCriteriaValueComponent,
    AutomationRuleComponent,
    AutomationRuleSummaryComponent
  ],
  exports: [
    AutomationCriteriaComponent,
    AutomationCriteriaValueComponent,
    AutomationRuleComponent
  ]
})
export class RuleAutomationModule { }
